import React from 'react';
import { bool, func, number } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import MessageHolder from 'components/messages/MessageHolder';
import { formatEstimatedTime } from 'utils/formatEstimatedTime';

function RefreshRankingsSuccessMessage({ visible, refreshedCount, skippedCount, estimateSeconds, onClose }) {
    if (!visible) {
        return null;
    }

    return (
        <MessageHolder onClose={onClose}>
            <div className="mg-modal-header is-success">
                <FontAwesomeIcon icon="check" aria-label="Success" />
            </div>
            <div className="mg-modal-content">
                <h3 className="font-30 uk-text-bold">
                    {refreshedCount > 0
                        ? `${refreshedCount} keyword${refreshedCount !== 1 ? 's' : ''} will be refreshed`
                        : 'No keywords will be refreshed.'}
                </h3>
                {refreshedCount > 0 && (
                    <p>
                        Your ranks will be ready <strong>in about {formatEstimatedTime(estimateSeconds)}</strong>.
                        {' '}Please wait or come back later.
                    </p>
                )}
                {skippedCount > 0 && (
                    <p>
                        <strong>
                            {skippedCount} keyword{skippedCount > 1 ? 's' : ''}
                        </strong>{' '}
                        {skippedCount > 1 ? 'were' : 'was'} skipped, because an on-demand scan for{' '}
                        {skippedCount > 1 ? 'them' : 'it'} is already in progress.
                    </p>
                )}
                <div>
                    <button className="mg-btn is-blue is-small" onClick={onClose} type="button">
                        OK, got it!
                    </button>
                </div>
            </div>
        </MessageHolder>
    );
}

RefreshRankingsSuccessMessage.propTypes = {
    visible: bool.isRequired,
    refreshedCount: number.isRequired,
    skippedCount: number.isRequired,
    estimateSeconds: number,
    onClose: func.isRequired,
};

export default RefreshRankingsSuccessMessage;
